/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityLockOpenIcon20Light = forwardRef('SecurityLockOpenIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.751 12.251c0 .514-.309.955-.751 1.148V15a.5.5 0 0 1-1 0V13.4a1.252 1.252 0 1 1 1.751-1.148Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 6a4 4 0 0 1 8 0v1.5a.5.5 0 0 1-1 0V6a3 3 0 1 0-6 0v2h.5a2.5 2.5 0 0 1 2.5 2.5v5a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 3 15.5v-5A2.5 2.5 0 0 1 5.5 8H12V6ZM5.5 9h8a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 4 15.5v-5A1.5 1.5 0 0 1 5.5 9Z" })));
});
